module.exports = __webpack_public_path__ + "static/media/container-dock.1b9fa125.jpeg";